export default class DsrConstants {
  static navigationWidth = 300;
  static rightSideWidth = 360;
  static sideMargin = 16;
  static contentPadding = 16;
  static topBarHeight = 72;
  static topBarHeightExtension = 64;
}
